module.exports = __webpack_public_path__ + "static/media/basket.7fbf7912.svg";